module.exports = __webpack_public_path__ + "static/media/allOrder.fbb81fd2.svg";